// lib/queryClient.ts
import { QueryClient } from '@tanstack/react-query';

// 创建一个全局唯一的 client 实例
export const queryClient = new QueryClient();
